import { isDateAHoliday } from './date';
import { validateInputs } from './error';
import {
  addLeadingZero,
  capitalizeFirstLetter,
  formatDate,
  formatDateCreatedAt,
  formatStringsToPlural,
} from './format';
import { getAntecedenceByInternationality, isAirportAgency, isInternationalAgency } from './generics';
import { handleClosePopUp } from './helpers';
import { getLocationResponse } from './initialData';
import { buildInternationalURL, buildNationalURL } from './submit';
import { filterTimeByAntecedenceHours, generateTimeArray } from './time';

export * from './helpers';

export const Utils = {
  date: {
    isDateAHoliday,
  },
  error: {
    validateInputs,
  },
  format: {
    addLeadingZero,
    capitalizeFirstLetter,
    formatDate,
    formatDateCreatedAt,
    formatStringsToPlural,
  },
  generics: {
    getAntecedenceByInternationality,
    isInternationalAgency,
    isAirportAgency,
  },
  helpers: {
    handleClosePopUp,
  },
  initialData: {
    getLocationResponse,
  },
  submit: {
    buildInternationalURL,
    buildNationalURL,
  },
  time: {
    filterTimeByAntecedenceHours,
    generateTimeArray,
  },
};
